export default __webpack_public_path__ + "static/media/doctor.a32e6703.png";